<template>
    <section>
        <h1 class="mb-0 mt-5 text-center">Blog</h1>
        <div class="blog-parent px-4" v-if="POSTS.length">
            <v-card class="pa-5 my-5 d-flex flex-column justify-space-between" v-for="(item, index) in POSTS" :key="index" v-if="!$vuetify.breakpoint.xs">
                <router-link :to="{name: 'AdminPost', query: {post_id: item.id}}">
                    <v-img :src="`${API_URL}/storage/${item.picture}`" width="100%" height="180px"/>
                </router-link>

                <v-card-title class="pa-0">{{item.title}}</v-card-title>

                <v-card-text class="pa-0">
                    <a :href="item.external_link" target="_blank" class="green--text mr-3" v-if="item.external_link">External Link</a>
                    <a :href="item.video_link" target="_blank" class="green--text" v-if="item.video_link">Video Link</a>
                </v-card-text>

                <v-card-text class="pa-0 black--text">
                    <strong>By:</strong>
                    {{item.teacher.full_name}}
                </v-card-text>

                <v-card-actions class="justify-space-between px-0">
                    <div class="d-flex align-center">
                        <svg v-svg="'icon-views'" size="20 12" class="mr-1"></svg>
                        <span>{{item.views}}</span>
                    </div>

                    <div class="d-flex justify-space-between">
                        <v-btn text class="pa-0 mr-2" @click="[$refs.edit.dialog = true, selectedPost = item.id]">
                            <svg v-svg="'icon-edit'" size="12" class="mr-1"></svg>
                            <span class="green--text">Edit</span>
                        </v-btn>

                        <v-btn text class="pa-0 ml-2" @click="[$refs.delete.dialog = true, selectedPost = item.id]">
                            <svg v-svg="'icon-delete'" size="12" class="mr-1"></svg>
                            <span class="red--text">Delete</span>
                        </v-btn>
                    </div>
                </v-card-actions>
            </v-card>

            <v-card v-for="(item, index) in POSTS" :key="index" class="pa-3 pr-5 mb-2 d-flex align-center" height="90" v-if="$vuetify.breakpoint.xs">
                <router-link :to="{name: 'AdminPost', query: {post_id: item.id}}">
                    <v-img :src="`${API_URL}/storage/${item.picture}`" max-width="106" max-height="68.65"></v-img>
                </router-link>

                <div class="d-flex flex-column justify-space-between ml-3">
                    <div>
                        <strong class="latest-post-title">{{item.title}}</strong>

                        <p class="by mb-0" v-if="$i18n.locale === 'am'">
                            {{item.teacher.full_name}}<strong>-ի կողմից</strong>
                        </p>
                        <p class="by mb-0" v-else>
                            <strong>By:</strong>
                            {{item.teacher.full_name}}
                        </p>
                    </div>

                    <div class="d-flex align-center justify-space-between">
                        <div>
                            <svg v-svg="'icon-views'" size="20 12" class="mr-1"></svg>
                            <span>{{item.views}}</span>
                        </div>

                        <div>
                            <v-btn text class="pa-0 mr-2" @click="[$refs.edit.dialog = true, selectedPost = item.id]">
                                <svg v-svg="'icon-edit'" size="12" class="mr-1"></svg>
                            </v-btn>

                            <v-btn text class="pa-0 ml-2" @click="[$refs.delete.dialog = true, selectedPost = item.id]">
                                <svg v-svg="'icon-delete'" size="12" class="mr-1"></svg>
                            </v-btn>
                        </div>
                    </div>
                </div>
            </v-card>
        </div>
        <p class="wait_for_blogs" v-else>Wait for our blogs (•_•) ( •_•)>⌐■-■ (⌐■_■)</p>
        <div class="float-end my-5 mr-16 pagination" v-if="POSTS.length">
            <v-pagination  v-model="pagination.current"
                           :length="pagination.total"
                           :total-visible="3"
                           color="green"
                           @input="getPosts"
            ></v-pagination>
        </div>

        <edit ref="edit" :post_id="selectedPost"></edit>
        <delete ref="delete" :post_id="selectedPost"></delete>
    </section>
</template>

<script>
    import Edit from '@/components/Admin/Blog/Edit';
    import Delete from '@/components/Admin/Blog/Delete';
    import {mapGetters} from 'vuex';
    export default {
        components: {
            Edit,
            Delete,
        },
        data(){
            return {
                selectedPost: null,
                pagination: {},
            }
        },
        computed: mapGetters(['POSTS']),
        mounted() {
            this.getPosts();
            this.$on('getPosts', function () {
                this.getPosts();
            })
        },

        methods: {
            getPosts(page){
                this.$apiAdmin('posts').get({params: {page: page}})
                    .then(res => {
                        const response = res.data.posts;
                        this.pagination.postsPerPage = response.per_page;
                        this.pagination.current = response.current_page;
                        this.pagination.total = response.last_page;
                        this.$store.dispatch('POSTS', response.data);
                    })
            }
        }
    }
</script>

<style scoped lang="scss">
    @import "../../../scss/pages/Blog/index";
</style>